import type { Nullable } from 'common/types'

import { ValueValidator } from '../../../../Validation'

export class NumberInputValidator extends ValueValidator<Nullable<number>> {
  constructor(min: number = -Infinity, max: number = Infinity) {
    super()

    const minConstraint = isFinite(min) ? min.toString() : 'минус бесконечности'
    const maxConstraint = isFinite(max) ? max.toString() : 'бесконечности'

    this.ruleFor('value')
      .greaterThanOrEqualTo(min)
      .withMessage(`Число должно быть больше или равно ${minConstraint}`)
      .lessThanOrEqualTo(max)
      .withMessage(`Число должно быть меньше или равно ${maxConstraint}`)
  }
}
